"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publicFeatureFlagSelector = void 0;

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var publicFeatureFlagSelector = function publicFeatureFlagSelector(state, featureKey) {
  var publicFeatureFlags = state.publicFeatureFlags;
  var override = localStorage.getItem(featureKey + "_OVERRIDE");

  if (override !== null && !(0, _ConfigSelectors.isAppAuthSelector)(state)) {
    if (override === 'true') return true;
    return false;
  }

  if (publicFeatureFlags && publicFeatureFlags[featureKey]) {
    return publicFeatureFlags[featureKey];
  }

  return null;
};

exports.publicFeatureFlagSelector = publicFeatureFlagSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PublicFeatureFlagSelectors.js
// module id = 286
// module chunks = 5 6 7